import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';

import TextPanel from '../../../../components/Editor/EditPanel/TextPanel';
import * as selectors from '../../selectors';

const mapStateToProps = (state: StoreState, ownProps) => {
	const { page } = ownProps;
	return {
		...ownProps,
		fontFamilyOptions: selectors.getFontFamilyOptions(state, page),
		fontSizeOptions: selectors.getFontSizeOptions(state, page),
		colorOptions: selectors.getColorOptions(state, page),
		lineHeightOptions: selectors.getLineHeightOptions(state, page),
		letterSpacingOptions: selectors.getLetterSpacingOptions(state, page),
	};
};

export default connect(mapStateToProps)(TextPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/TextPanel/index.tsx